<template>
  <v-dialog
    v-model="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
        dense
      >Добавление топлива ГОСТ </v-toolbar>
      <ref-fuel-grade-card :mode="'editor'" :grade="localGrade" @onGradeUpdate="doGradeUpdate"></ref-fuel-grade-card>
      <v-card-actions>
        <v-btn class="secondary" @click="doClose">
          Отмена
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="primary" outlined dark :disabled="saveDisabled" @click="doSave">
          {{btnText}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import axios from 'axios'
import RefFuelGradeCard from '@/components/modules/references/cards/refFuelGradeCard'

export default {
  name: 'refAddGrade2GOSTDialog',
  components: { RefFuelGradeCard },
  props: ['grade', 'value'],
  data () {
    return {
      localGrade: null
    }
  },
  computed: {
    btnText: {
      get () {
        return this.localGrade ? this.localGrade.GRADE_ID ? 'Сохранить' : 'Создать' : ''
      }
    },
    dataNew: {
      get: function () {
        return !this.localGrade.GRADE_ID
      }
    },
    dataChanged: {
      get () {
        // console.log('refAddGrade2GOSTDialog dataChanged requested. grade is: ', this.grade)
        if (!this.grade) return false
        if (this.dataNew) return true
        return this.grade.GOST !== this.localGrade.GOST || this.grade.GOST.GOST_CODE !== this.localGrade.GOST.GOST_CODE || this.grade.GRADE_NAME !== this.localGrade.GRADE_NAME || this.grade.GRADE_CODE !== this.localGrade.GRADE_CODE || !this.localGrade.OKPD || !this.localGrade.OKPD.OKPD_ID
      }
    },
    saveDisabled: {
      get: function () {
        if (!this.localGrade) return true
        const noName = !this.localGrade.GRADE_NAME
        const noCode = !this.localGrade.GRADE_CODE
        const noGOST = !this.localGrade.GOST || !this.localGrade.GOST.GOST_ID
        const noOKPD = !this.localGrade.OKPD || !this.localGrade.OKPD.OKPD_ID
        return noName || noCode || noGOST || noOKPD || !this.dataChanged
      }
    }
  },
  watch: {
    grade (val) {
      // console.log('refAddGrade2GOSTDialog grade changed to ', val)
      if (val) {
        // eslint-disable-next-line no-undef
        this.localGrade = structuredClone(this.grade)
      } else {
        this.localGrade = null
      }
    }
  },
  methods: {
    doSave () {
      const self = this
      const action = this.localGrade.GRADE_ID ? 'update' : 'add'
      const processorPath = action === 'update' ? '/api/org/references/updGrade2GOST.php' : '/api/org/references/addGrade2GOST.php'
      const payload = { ...this.localGrade }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            if (action === 'add') {
              self.$emit('gradeAdded', [resp.data.data])
            } else {
              self.$emit('gradeUpdate', [resp.data.data])
            }
            self.$emit('input', false)
          } else {
            self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    },
    doClear () {
    },
    doClose () {
      this.doClear()
      this.$emit('input', false)
    },
    doGradeUpdate (data) {
      // console.log('refAddGrade2GOSTDialog:: doGradeUpdate method called ', data)
      this.localGrade = { ...this.localGrade, ...data }
      // console.log('refAddGrade2GOSTDialog:: doGradeUpdate current data is ', this.localGrade, ' original data is ', this.grade)
    }
  },
  mounted () {
    // console.log('refAddGrade2GOSTDialog mounted with grade ', this.grade)
  }
}
</script>
